
import apiService from "../../services/apiService";

const loadPagesInfo = (setLoadPages) => {

    const selectedProject = localStorage.getItem('selectedProject');

    //  escapes when there is no selection
    if (selectedProject === -1) return;
    const projects = JSON.parse(localStorage.getItem('data'));
    const projectToDownload = projects[selectedProject];
    if(projectToDownload === undefined) return;
    if (projectToDownload.pages.length === 0) return;
    Promise.all(
    projectToDownload.pages.map((pageToDownload) =>
        //  the code bellow might seems strange but it formats for the first time the page id
        apiService.readPage({
        pageId: (pageToDownload.pageId) || pageToDownload
        })
    )
    )
    .then((responses) => responses.map((response) => response))
    .then((pages) => {
        projectToDownload.pages = pages;
        return projectToDownload;
    })
    .then((updatedProject) => {
        projects[selectedProject] = updatedProject;
        return projects;
    })
    .then((updatedProjects) => {
        updatedProjects.forEach( (project,index) => {

            if( Number(index) !== Number(selectedProject)){
              project.pages.forEach( (page,index2) => {
                if(page.pageId !== undefined){
                  updatedProjects[index].pages[index2] = page.pageId;
                }
              }) 
            }
        })

        localStorage.setItem('data', JSON.stringify(updatedProjects));
        if (setLoadPages !== undefined) {
            setLoadPages(true);
        }
    })
    .catch((error) => {throw error;});
}

export default loadPagesInfo